/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Sources_Plan_ChangeInputs */

const es_admin_billing_sources_plan_change = /** @type {(inputs: Admin_Billing_Sources_Plan_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de plan`)
};

const en_admin_billing_sources_plan_change = /** @type {(inputs: Admin_Billing_Sources_Plan_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan change`)
};

/**
* | output |
* | --- |
* | "Plan change" |
*
* @param {Admin_Billing_Sources_Plan_ChangeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_sources_plan_change = /** @type {((inputs?: Admin_Billing_Sources_Plan_ChangeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Sources_Plan_ChangeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_sources_plan_change(inputs)
	return en_admin_billing_sources_plan_change(inputs)
});
export { admin_billing_sources_plan_change as "admin.billing.sources.plan_change" }